import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import OrdersRatingHeader from './OrdersRatingHeader';
import OrdersRatingList from './OrdersRatingList';
import { ordersRatingStore } from './store/ordersRatingStore';

const OrdersRatingScreen = () => {
  useEffect(() => {
    ordersRatingStore.getOrdersRating(ordersRatingStore.pagination.currentPage);
  }, []);

  return (
    <>
      <OrdersRatingHeader />
      <OrdersRatingList />
    </>
  );
};

export default observer(OrdersRatingScreen);
